module.exports = __webpack_public_path__ + "static/media/yacht-background.4af54d0d.png";